import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-upload-logo',
  templateUrl: './upload-logo.component.html',
  styleUrls: ['./upload-logo.component.scss']
})
export class UploadLogoComponent implements OnInit {
  @Input() srcLogo?: string;
  @Input() isSmall = false;
  @Input() shouldShowPlaceholderText = true;
  @Input() isLoading: boolean = false;
  @Output() fileUploaded = new EventEmitter<File | undefined>();


  photoAllowedExt: string[] =  ['.png', '.jpg','.jpeg'];
  fileSize: number = 2097152; // convert 2MB to bytes ( 1,048,576 Bytes *2 )
  constructor() { }

  ngOnInit(): void {
  }

  uploadImage(event: any){
    const file = event.target.files[0];
    this.fileUploaded.emit(file);
  }

}
